var React = require('react');

function IconReportLostDeals (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0ZM3.43,18A14.47,14.47,0,0,1,6.6,8.93L27,29.38A14.55,14.55,0,0,1,3.43,18Zm26,9L9,6.58A14.56,14.56,0,0,1,32.57,18,14.37,14.37,0,0,1,29.42,27Z"}));
}

IconReportLostDeals.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = IconReportLostDeals;

IconReportLostDeals.default = IconReportLostDeals;
